export const MAPPING = {
    EVENTS: 'events',
    REPORTS: 'reports',
    WANTED_LIST: 'wanted-list',
    COMMUNITY: {
        ARTICLE: 'community-article',
        VIDEO: 'community-video',
    },
    GENERAL: {
        NEWS: 'general-news',
        VIDEO: 'general-video',
        GOOGLE_NEWS: 'general-google-news',
    },
    SCHOOLS: 'school',
};
